<template>
  <div>
    <div style="margin-bottom:100px ">
      <span>产品：</span>
      <v-select style="width: 220px;margin-right: 100px"
                :data="appOptions"
                placeholder="选择产品组"
                :allowClear="false"
                v-model="appValue"></v-select>
      <span>时间：</span>
      <v-date-picker range
                     placeholder="请选择时间段"
                     style="width:270px;margin-right: 20px"
                     v-model="rangeDate"
                     clearable></v-date-picker>
      <v-button type="primary"
                @click="search">筛选</v-button>
    </div>
    <v-chart id="chart"
             style="width: 65vw;height: 50vh"
             ref="chart"
             :options="option" />
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title.js'
import axios from 'axios'
function stringToTimestamp (value) {
  let date = value
  date = date.substring(0, 19)
  date = date.replace(/-/g, '/')
  const timestamp = new Date(date).getTime()
  return timestamp / 1000
}
function timestampToString (timestamp, flag) {
  let time = 0
  if (flag === 'start') {
    time = timestamp - 86400 * 7
  } else {
    time = timestamp
  }
  let d = new Date(time * 1000)
  let date = (d.getFullYear()) + '-' +
    (d.getMonth() + 1) + '-' +
    (d.getDate()) + ' '
  return date
}
export default {
  name: 'appraise',
  components: {
    'v-chart': ECharts
  },
  data () {
    return {
      option: {
        color: ['#003366'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          backgroundColor: 'rgba(245, 245, 245, 0.8)',
          borderWidth: 1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000'
          }
        },
        legend: {},
        xAxis: {
          type: 'category',
          data: [],
          name: '评价原因'
        },
        yAxis: [{
          type: 'value',
          position: 'left',
          name: '评价人数（人）',
          splitLine: {show: false},
          min: 0,
          max: function (value) {
            console.log(value.max - value.max % 10 + 10)
            return value.max - value.max % 10 + 10
          }
        }, {
          type: 'value',
          position: 'right',
          name: '评价占比（%）',
          minInterval: 1,
          min: 0,
          max: function (value) {
            return value.max === 100 ? 100 : value.max - value.max % 10 + 10 || 100
          },
          // interval: 20,
          splitLine: {show: false}
        }],
        series: [{
          name: '评价人数（人）',
          type: 'bar',
          barWidth: '30%',
          data: [],
          itemStyle: {
            barBorderRadius: 1,
            color: function (params) {
              let colorList = [
                '#163EC0',
                '#2058BF',
                '#2374CF',
                '#2272AF',
                '#318DC1',
                '#38A1CD',
                '#38BEDA',
                '#CBA531',
                '#CB8326',
                '#CA5F25'
              ]
              return colorList[params.dataIndex]
            }
          }

        }, {
          type: 'line',
          name: '评价占比（%）',
          yAxisIndex: 1,
          data: []
        }]
      },
      appOptions: [],
      appValue: '',
      rangeDate: ['', '']
    }
  },
  computed: {
    startTime: function () {
      return stringToTimestamp(this.rangeDate[0])
    },
    endTime: function () {
      return stringToTimestamp(`${this.rangeDate[1]} 23:59:59`)
    }
  },
  methods: {
    search () {
      axios.post('/dev/delete_order/statistical', { app_key: this.appValue, start_time: this.startTime, end_time: this.endTime })
        .then(res => {
          let data = res.data.statistical
          let totalAmount = res.data.total

          this.option.xAxis.data = data.map(item => {
            return item.name
          })
          this.option.series[0].data = data.map(item => {
            return item.count
          })
          this.option.series[1].data = data.map(item => {
            return parseInt((item.count / totalAmount * 100).toFixed(0))
          })
          console.log(this.option)
          this.$refs.chart.refresh()
        })
    },
    initData () {
      axios.get('/dev/package_info').then(res => {
        let arr = []
        // let arr = []
        res.data.package_info.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.appOptions = arr
        this.appValue = arr[0].value
        this.search()
      })
    }
  },
  created () {
    this.rangeDate = [timestampToString(Math.round(new Date() / 1000), 'start'), timestampToString(Math.round(new Date() / 1000), 'end')]
  },
  mounted () {
    this.initData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/appraise/appraise.vue